import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';

import UsuarioProvider from './Context/UsuarioProvider';
import LibrosProvider from './Context/LibrosProvider';

ReactDOM.render(
  <React.StrictMode>
    <UsuarioProvider>
      <LibrosProvider>

        <App />
      
      </LibrosProvider>
    </UsuarioProvider>
  </React.StrictMode>,
  document.getElementById('root')
);